import React from 'react';
import PropTypes from 'prop-types';
import {
  // components
  Box,
  ButtonIcon,
  Layout,
  View,
  // helpers
  ALIGN,
  COLOR,
  DISPLAY,
  SPACE,
  POSITION,
} from '@lookiero/aurora';

import {scrollToElement} from '@views/_bridges';
import {style} from './SectionLink.style';

const SectionLink = ({elementToScroll}) => (
  <View position={POSITION.ABSOLUTE} style={style.container}>
    <Layout justifyContent={ALIGN.CENTER}>
      <Box
        display={DISPLAY.FLEX}
        justifyContent={ALIGN.CENTER}
        size={{M: '2/3', L: null}}
        textAlign={ALIGN.CENTER}
        marginBottom={SPACE.SPACE_8}
        wide={true}
      >
        <ButtonIcon color={COLOR.ICON} name="arrow-down" onPress={() => scrollToElement(elementToScroll)} />
      </Box>
    </Layout>
  </View>
);

SectionLink.propTypes = {
  elementToScroll: PropTypes.string.isRequired,
};

export {SectionLink};
